import apiUser from "../../api";
import {
  accountFilterFields,
  activityFilterFields,
  companyFilterField,
  designationFilterField,
  settledRows,
  userFullName,
} from "../../features/user.filter";

// Advanced filter for the admins list (see ../../features/user.filter.js).
export const filterFields = [
  companyFilterField,
  designationFilterField,
  { key: "assigned_employee_fids", label: "Assigned Employees", type: "select", group: "Organization", optionsKey: "employees", optionLabelFormatter: userFullName },
  ...accountFilterFields,
  ...activityFilterFields,
];

// Dropdown data for the filter, fetched once when the drawer first opens.
export const loadFilterDependencies = async () => {
  const [companiesRes, designationsRes, employeesRes] = await Promise.allSettled([
    apiUser.getCompanies(),
    apiUser.getDesignations(),
    apiUser.getAllClients({ role: "EMPLOYEE" }),
  ]);

  return {
    companies: settledRows(companiesRes),
    designations: settledRows(designationsRes),
    employees: settledRows(employeesRes),
  };
};
